module.exports = __webpack_public_path__ + "static/media/material_preparacion.e3d1f17e.png";